import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
    titanium,
    text,
    cloud,
    silver,
    steel,
    purple,
    violet,
    graphite,
    RadioButton,
    RoundedButton,
    Modal,
} from '@rover/react-bootstrap'

import { DownloadIcon } from '@rover/react-icons'
import CreateDeviceExportMutation from '../../mutations/CreateDeviceExportMutation'
import GetDeviceExportQuery from '../queries/GetDeviceExportQuery '

class DeviceExportModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentSelected: 'current',
            isDownloading: false,
            pollingInterval: null,
        }

        this.changeSelected = this.changeSelected.bind(this)
        this.download = this.download.bind(this)
        this.onRequestClose = this.onRequestClose.bind(this)
        this.checkExportDone = this.checkExportDone.bind(this)
        this.startPolling = this.startPolling.bind(this)
        this.stopPolling = this.stopPolling.bind(this)
    }

    changeSelected(type) {
        this.setState({ currentSelected: type })
    }

    download() {
        this.setState({ isDownloading: true })

        const { currentSelected } = this.state
        const { selectedColumns } = this.props

        let fields = []
        if (currentSelected === 'current') {
            Object.keys(selectedColumns).forEach(key => {
                let attr = selectedColumns[key].attribute
                if (key.endsWith('CUSTOM_DEVICE')) {
                    attr = `userInfo.${attr}`
                }
                fields.push(attr)
            })
        }

        CreateDeviceExportMutation([], 'ALL', fields)
            .then(res => {
                const { id } = res
                this.setState({ exportId: id })
                this.startPolling()
            })
            .catch(err => {
                console.error(err)
                this.onRequestClose()
            })
    }

    startPolling() {
        const intervalId = setInterval(this.checkExportDone, 1000)
        this.setState({ pollingInterval: intervalId })
    }

    stopPolling() {
        const { pollingInterval } = this.state
        if (pollingInterval) {
            clearInterval(pollingInterval)
            this.setState({ pollingInterval: null })
        }
    }

    checkExportDone() {
        const { exportId } = this.state
        GetDeviceExportQuery(exportId)
            .then(res => {
                if (res.done) {
                    this.stopPolling()
                    if (res.error) {
                        alert(res.error)
                        return this.onRequestClose()
                    }

                    const anchor = document.createElement('a')
                    anchor.setAttribute('href', res.file)
                    anchor.setAttribute('download', '')
                    anchor.click()
                    this.onRequestClose()
                }
            })
            .catch(err => {
                console.error(err)
                this.onRequestClose()
            })
    }

    onRequestClose() {
        this.stopPolling()
        this.setState({
            currentSelected: 'current',
            pollingInterval: null,
            isDownloading: false,
        })

        this.props.onRequestClose && this.props.onRequestClose()
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }

    render() {
        const { isOpen, totalSize } = this.props

        const { currentSelected, isDownloading } = this.state

        return (
            <Modal
                isOpen={isOpen}
                onRequestClose={this.onRequestClose}
                style={{
                    content: {
                        backgroundColor: 'white',
                        padding: 0,
                        width: 'auto',
                        overflow: 'hidden',
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    },
                }}
                hoverStyle={{
                    backgroundColor: titanium,
                }}
            >
                <div
                    style={{
                        minHeight: 110,
                        maxHeight: 450,
                        width: 400,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {/* Header */}
                    <div
                        style={{
                            height: 50,
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: cloud,
                            paddingLeft: 20,
                            color: steel,
                            fontSize: 14,
                            ...text,
                        }}
                    >
                        <DownloadIcon fill={silver} />
                        <div style={{ marginLeft: 10 }}>
                            Export{' '}
                            <span style={{ fontWeight: 'bold', color: graphite }}>
                                {this.numberWithCommas(totalSize)}
                            </span>{' '}
                            Devices
                        </div>
                    </div>
                    {/* Body */}
                    <div
                        style={{
                            paddingTop: 24,
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingBottom: 20,
                        }}
                    >
                        <span style={{ color: silver, fontSize: 13 }}>
                            Which columns should be included in the export?
                        </span>
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', marginTop: 14 }}>
                            <RadioButton
                                label={<span style={{ color: graphite }}>Currently Displayed Columns</span>}
                                isChecked={currentSelected === 'current'}
                                disabled={isDownloading}
                                onChange={() => this.changeSelected('current')}
                                primaryColor={purple}
                            />
                            <RadioButton
                                label={<span style={{ color: graphite }}>All Columns</span>}
                                isChecked={currentSelected === 'all'}
                                disabled={isDownloading}
                                onChange={() => this.changeSelected('all')}
                                primaryColor={purple}
                                labelStyle={{
                                    marginLeft: 17,
                                }}
                            />
                        </div>
                        <RoundedButton
                            type="primary"
                            primaryColor={purple}
                            hoverColor={violet}
                            style={{ marginTop: 30, width: 124 }}
                            onClick={this.download}
                            isLoading={isDownloading}
                        >
                            Download
                        </RoundedButton>
                    </div>
                </div>
            </Modal>
        )
    }
}

DeviceExportModal.propTypes = {
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    totalSize: PropTypes.number.isRequired,
}

DeviceExportModal.defaultProps = {
    isOpen: false,
    onRequestClose: () => null,
    totalSize: 0,
}

export default DeviceExportModal
